import { useEffect } from 'react';
import { fetchIssuers } from '../../store/action_creators/issuer.actions';
import { RootState } from '../../store/config/types';
import { ThunkDispatch } from 'redux-thunk';
import { AppActions } from './../../store/config/ActionTypes';
import { connect, ConnectedProps } from 'react-redux';

const mapStateToProps = (state: RootState) => ({
  issuer: state.issuer,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  fetchIssuers: () => dispatch(fetchIssuers()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

function PaymentMethod({ issuer, fetchIssuers }: PropsFromRedux) {
  useEffect(() => {
    if (!issuer.loadingIssuers && issuer.issuers === null && issuer.issuersErrorMessage === null) {
      fetchIssuers();
    }
  }, [issuer.loadingIssuers, issuer.issuers, issuer.issuersErrorMessage, fetchIssuers]);

  return (
    <div className="payment-method">
      <div className="payment-method-title">Medios de pago disponibles:</div>
      <div className="payment-method-description">
        {issuer.issuers &&
          issuer.issuers.map((payment) => {
            return (
              <img
                className="payment-method-description-single"
                src={payment.issuerImageUrl}
                alt={payment.name}
                key={payment.id}
              />
            );
          })}
      </div>
    </div>
  );
}

export default connector(PaymentMethod);
